import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseUrl } from '../../api/main'
import { Cookies } from 'react-cookie'
const cookie = new Cookies()
const token = cookie.get('token')

export const apiRtkSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/api`,
    prepareHeaders: (headers, { getState }) => {
      // Add your custom headers here
      headers.set('Authorization', `Bearer ${token}`)
      headers.set('Content-Type', 'application/json')
      return headers
    },
  }),
  tagTypes: ['Video', 'Audio', 'File'],
  endpoints: (builder) => ({}),
})
